import React from 'react';
import { useLocation } from 'react-router-dom';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import NavBar from './NavBar';
import { isWorkspacePath } from './WorkspaceHeading';
import { PublicFooter } from './PublicLayout';
import './entremapHome.css';
import './entremapWorkspace.css';

export const workspaceTheme = createMuiTheme({
  palette: {
    primary: { main: '#00624d', dark: '#064f40', contrastText: '#fff' },
    secondary: { main: '#c3451e', dark: '#a63616', contrastText: '#fff' },
    background: { default: '#f5f8f5', paper: '#fff' },
    text: { primary: '#122c33', secondary: '#586b70' },
    error: { main: '#a82f25' },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
    button: { textTransform: 'none', fontWeight: 650, fontSize: 14 },
    body1: { lineHeight: 1.7 }, body2: { lineHeight: 1.65 },
    h4: { fontWeight: 700, letterSpacing: '-.6px' },
    h5: { fontWeight: 650, letterSpacing: '-.4px' },
    h6: { fontWeight: 650 },
  },
  shape: { borderRadius: 14 },
  overrides: {
    MuiPaper: { rounded: { borderRadius: 16 }, elevation1: { boxShadow: '0 5px 24px rgba(18,44,51,.045)' } },
    MuiCard: { root: { border: '1px solid #e1e9e3', boxShadow: '0 5px 24px rgba(18,44,51,.035)' } },
    MuiCardContent: { root: { padding: 24 } },
    MuiButton: {
      root: { borderRadius: 30, minHeight: 44, padding: '10px 22px', lineHeight: 1.4 },
      contained: { boxShadow: 'none' },
      containedPrimary: { backgroundColor: '#c3451e', '&:hover': { backgroundColor: '#a63616', boxShadow: 'none' } },
      outlined: { borderColor: '#c7d8ce' },
    },
    MuiOutlinedInput: { root: { borderRadius: 10, backgroundColor: '#fff' }, notchedOutline: { borderColor: '#cbd8d0' } },
    MuiFilledInput: { root: { borderRadius: '10px 10px 0 0', backgroundColor: '#f0f5f1', '&:hover': { backgroundColor: '#e8f0eb' } } },
    MuiTableCell: { root: { padding: '16px 20px', borderBottom: '1px solid #e8eee9', fontSize: 14 }, head: { backgroundColor: '#f1f6f2', color: '#38544b', fontWeight: 650 } },
    MuiTab: { root: { textTransform: 'none', minHeight: 52, fontWeight: 650 } },
    MuiDialog: { paper: { borderRadius: 18 } },
    MuiMenuItem: { root: { minHeight: 44, fontSize: 14 } },
    MuiLinearProgress: { root: { height: 7, borderRadius: 8, backgroundColor: '#e3ede5' }, barColorPrimary: { backgroundColor: '#00624d' } },
  },
});

export default function WorkspaceLayout({ children, isLoggedIn }) {
  const { pathname } = useLocation();
  if (!isWorkspacePath(pathname)) return children;
  const key = pathname.toLowerCase().replace(/\/$/, '');
  const needsChrome = ['/invite', '/qut-signup', '/teacher-login'].includes(key);
  return <ThemeProvider theme={workspaceTheme}>
    <div className="emap-home emap-workspace" data-page={key.slice(1) || 'not-found'}>
      <a href="#workspace-content" className="emap-skip-link">Skip to content</a>
      {needsChrome && <NavBar isLoggedIn={isLoggedIn === true} />}
      <div className="emap-route-content">{children}</div>
      {needsChrome && <PublicFooter />}
    </div>
  </ThemeProvider>;
}
